import React, { useState } from 'react';

const Solutions = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div className="relative bg-white">
      {/* Content */}
      <div className="relative z-10 px-4 md:px-24 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className="mt-2 md:mt-2 md:mb-5 flex justify-between items-center p mb-2">
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#979797] md:mb-3">
            EXPERIENCE APP <span className='text-[#152C24]'>CONTRACTS FARMING</span>
          </h1>
          <div>
            <div className='flex md:gap-2 gap-1 justify-center md:mt-2'>
              <div className='bg-[#CFD7D7] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
              <div className="bg-[#2E453D] border-b-2 border-[#FFBD26] md:ml-0 ml-2 text-white font-normal md:px-6 px-2 rounded-md md:rounded-[30px] w-[70px] h-[15px] md:w-[150px] md:text-[20px] text-[6px] md:h-[40px] mt-0 md:-mt-[1px] flex justify-between items-center">
                See More
              </div>
              <div className='bg-[#2E453D] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 mr-2 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
            </div>
          </div>
        </div>

        {/* Resources Section */}
        <div className="rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 pt-2 md:mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[180px] md:mt-5 md:h-[700px] flex justify-center items-center cursor-pointer">
            {showVideo ? (
              <div className="w-full h-full">
                <video
                  src="https://res.cloudinary.com/dwfdzdaxk/video/upload/v1751107713/Farmnet_demo_videos_website-Contract_Farming_aw21hx.mp4"
                  controls
                  autoPlay
                  className="w-full h-full object-cover"
                />
               
                <img
                  onClick={() => setShowVideo(false)}
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751046974/close_ring_duotone_ralxeq.png"
                  alt="Close"
                  className="absolute top-2 right-2 md:w-16 md:h-16 w-2 h-2 mt-1"
                /> 
              </div>
            ) : (
              <>
                <img
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751110054/Screenshot_2025-06-28_at_4.32.05_PM_bhoxmv.png"
                  alt="Mobile"
                  className="object-cover w-full h-full"
                />
                {/* Play Icon */}
                <div
                  onClick={() => setShowVideo(true)}
                  className="absolute inset-0 flex justify-center items-center cursor-pointer"
                >
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                    alt="Play Icon"
                    className="w-[50px] h-[50px] md:w-[110px] md:h-[110px] object-contain"
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {/* Description */}
        <div className='md:text-[32px] text-[10px] font-normal md:mt-16 mt-2 space-y-6'>
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#979797] md:mb-3">
            SOLUTION | <span className='text-[#152C24]'>CONTRACTS  FARMING</span>
          </h1>

          <div className="space-y-2 sm:space-y-1">
            <h2 className="md:text-[32px] font-bold text-[10px]">Problems</h2>
            <p className="md:text-[32px] sm:text-[8px]">Market Uncertainty & Price Fluctuations</p>
            <p className="md:text-[32px] sm:text-[8px]">Limited Access to Buyers & Formal Markets</p>
            <p className="md:text-[32px] sm:text-[8px]">Lack of Access to Inputs (Seeds, Fertilizer, Equipment)</p>
            <p className="md:text-[32px] sm:text-[8px]">Financial Constraints / Lack of Credit</p>
            <p className="md:text-[32px] sm:text-[8px]">Poor Farming Practices & Low Yields</p>
            <p className="md:text-[32px] sm:text-[8px]">Post-Harvest Losses & No Storage</p>
            <p className="md:text-[32px] sm:text-[8px]">Lack of Trust or Exploitation</p>
          </div>

          <div className="space-y-2 sm:space-y-1">
            <h2 className="md:text-[32px] font-bold text-[10px]">Solutions</h2>
            <p className="md:text-[32px] text-[8px]">§ Contract farming provides a pre-agreed price and buyer, ensuring income stability and reducing exploitation by middlemen.</p>
            <p className="md:text-[32px] text-[8px]">§ The app connects farmers directly with verified companies or buyers (e.g., exporters, processors) through digital contracts.</p>
            <p className="md:text-[32px] text-[8px]">§ Contract farming includes input support - companies supply seeds, fertilizer, and sometimes tools in exchange for guaranteed produce.</p>
            <p className="md:text-[32px] text-[8px]">§ The contract serves as proof of future income, improving creditworthiness and enabling farmers to access loans or mobile finance.</p>
            <p className="md:text-[32px] text-[8px]">§ Contracts often include technical support or extension services delivered through the app or in-person, improving farming techniques.</p>
            <p className="md:text-[32px] text-[8px]">§ Smart contracts on the app add transparency with clear terms, digital records, and ratings for both parties.</p>
          </div>
        </div>
        
        <div className="w-1/2">
          <h1 className="text-[18px] md:text-[32px] font-bold mt-8 mb-4 text-black">
            Download App
          </h1>
          <div className="flex flex-row justify-between space-x-2 items-center sm:space-y-0">
           <a href="https://play.google.com/store/apps/details?id=com.farmnet.africa&pcampaignid=web_share" alt="none">      <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751889690/google_PLAY-LOGO.WINE_emyxpu.png" className="h-[25px] md:w-[280px] md:h-[180px]" alt="App Store" />      </a>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png"
              alt="Google Play"
              className="h-[30px] md:h-[75px] object-contain"
            />
          </div>
        </div>
        <div className='md:h-10 h-5'></div>
      </div>
    </div>
  );
};

export default Solutions;